var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf"},[_c('iframe',{ref:"viframe",staticStyle:{"width":"100%","height":"99%","border":"none"},attrs:{"src":'https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(_vm.url)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f8081c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/components/wOffice.vue
// module id = null
// module chunks = 